module.exports = __webpack_public_path__ + "static/media/star-bg.c421175b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/star-bg.png
// module id = 117
// module chunks = 0